import React from "react";

const BreadcrumbContainer = ({ children }) => {
  return (
    <div className="breadcrumb-area">
      <div
        className="container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default BreadcrumbContainer;
